<script setup>
import { CONTACT_INFO, PRACTICE_NAME, THERAPIST_NAME } from "@/content/site";

import { ROUTES } from "@/app/router";
</script>

<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3 class="label label-light">Kontakt</h3>
        <p>
          <strong>E-Mail: </strong>
          <a :href="`mailto:${CONTACT_INFO.email}`">{{ CONTACT_INFO.email }}</a>
        </p>
        <p>
          <strong>Telefon: </strong>
          <a :href="`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`">{{
            CONTACT_INFO.phone
          }}</a>
        </p>
      </div>

      <div class="footer-section">
        <h3 class="label label-light">Adresse</h3>
        <p>{{ PRACTICE_NAME }}</p>
        <p>{{ THERAPIST_NAME }}</p>
        <p>{{ CONTACT_INFO.address.street }}</p>
        <p>{{ CONTACT_INFO.address.zipCity }}</p>
      </div>

      <div class="footer-section">
        <h3 class="label label-light">Öffnungszeiten</h3>
        <p>Mo: {{ CONTACT_INFO.openingHours.monday }}</p>
        <p>Di: {{ CONTACT_INFO.openingHours.tuesday }}</p>
        <p>Mi: {{ CONTACT_INFO.openingHours.wednesday }}</p>
        <p>Do: {{ CONTACT_INFO.openingHours.thursday }}</p>
        <p>Fr: {{ CONTACT_INFO.openingHours.friday }}</p>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-left">
        <p>
          &copy; {{ new Date().getFullYear() }} {{ THERAPIST_NAME }}. Alle
          Rechte vorbehalten.
        </p>
      </div>
      <div class="footer-bottom-center">
        <router-link :to="ROUTES.IMPRESSUM" class="footer-link"
          >Impressum</router-link
        >
        <span class="separator">|</span>
        <router-link :to="ROUTES.DATENSCHUTZ" class="footer-link"
          >Datenschutz</router-link
        >
      </div>

      <div class="footer-bottom-right">
        <a href="https://www.bmev.de">
          <img
            src="@/assets/images/logo_bmev.svg"
            alt="Logo des Bundesverbandes Mediation"
          />
        </a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: var(--page-bg-overlay);
  color: var(--color-cream);
  padding: var(--spacing-md) var(--spacing-md) var(--spacing-md);
  margin-top: var(--spacing-xl);
  width: 100%;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-md);
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: var(--spacing-md);
}

.footer-section h3 {
  margin-bottom: var(--spacing-sm);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-normal);
}

.footer-section p {
  margin: var(--spacing-xs) 0;
  line-height: var(--line-height-compact);
  font-size: var(--font-size-m);
}

.footer-section a {
  color: var(--color-cream-dark);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.footer-section a:hover {
  color: var(--color-cream);
}

.footer-bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: var(--spacing-xs);

  border-top: 1px solid rgba(245, 230, 163, 0.15);
  color: var(--color-cream);
  font-size: var(--font-size-xs);
  max-width: 1200px;
  opacity: 0.7;
}

.footer-bottom-left {
  flex: 1;
  text-align: left;
}

.footer-bottom-left p {
  font-size: var(--font-size-xs);
}

.footer-bottom-center {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: var(--spacing-sm);
}

.footer-bottom-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  margin-bottom: auto;
}

.footer-bottom-right img {
  width: 100px;
  padding-bottom: -10px;
}

.footer-link {
  color: var(--color-cream);
  text-decoration: none;
  transition: color var(--transition-fast);
  font-size: var(--font-size-xs);
}

.footer-link:hover {
  color: var(--color-cream-dark);
}

.separator {
  color: var(--color-cream);
  opacity: 0.5;
  font-size: var(--font-size-xs);
}

@media (max-width: 768px) {
  .footer {
    padding: var(--spacing-md) var(--spacing-md) var(--spacing-md);
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: var(--spacing-md);
  }

  .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-sm);
  }

  .footer-bottom-left {
    text-align: center;
  }
}
</style>
